import { useNavigate, Link, useLocation } from "react-router-dom";
import ModalForm from "./login-form/modal_template";
import authApi from "network/auth/network";
import useAuth from "hooks/useAuth";
import { createLogger } from '../../../utils/logger';
import { getDefaultPanelPath } from "../../../utils/panel-access";

const logger = createLogger('login');
interface IFormData {
  username: string;
  password: string;
}

export default function Login() {
  const { setAuth, setRoles }: any = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname;

  const handleSubmit = async (formData: IFormData) => {
    try {
      let response = await authApi.login(formData.username, formData.password)

      if (response) {
        localStorage.setItem("token", response.token);
        localStorage.setItem(
          "userRole",
          JSON.stringify(response.accessScopes)
        );
        setAuth(response.token);
        setRoles?.(response.accessScopes?.map((role: string | number) => Number(role)) || []);
        nav(from && from !== "/auth" ? from : getDefaultPanelPath(response.accessScopes?.map((role: string | number) => Number(role)) || []), { replace: true });
      }
    } catch (error) {
      logger.error('Login error', error);
    }
  };

  return <ModalForm onSubmited={handleSubmit} />;
}
